import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { formatValue, unformatValue } from "../../../components/PaymentContainer/components/PaymentSelection/components/PaymentDetailsSection/InputSection/components/PhoneInput/utils";
import { formatValue as formatSumValue, unformatValue as unformatSumValue } from "../../../components/PaymentContainer/components/PaymentSelection/components/PaymentDetailsSection/InputSection/components/SumInput/utils";
import { produce } from "../../../../libs/immer";
import { EPaymentUrlParam } from "../constants";
import { clearParams } from "../utils";
export var emailStrategy = {
  predicate: function predicate(params) {
    return !!params[EPaymentUrlParam.Sum] && !!params[EPaymentUrlParam.AccountNumber];
  },
  request: function () {
    var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params, content, setState) {
      var sum, accountNumber;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            sum = formatSumValue(unformatSumValue(params[EPaymentUrlParam.Sum]));
            accountNumber = formatValue(unformatValue(params[EPaymentUrlParam.AccountNumber]));
            clearParams([EPaymentUrlParam.Sum, EPaymentUrlParam.AccountNumber]);
            setState(produce(function (draft) {
              draft.sumInput.value = sum !== null && sum !== void 0 ? sum : '';
              draft.phoneInput.value = accountNumber !== null && accountNumber !== void 0 ? accountNumber : '';
            }));
            return _context.abrupt("return", undefined);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function request(_x, _x2, _x3) {
      return _request.apply(this, arguments);
    }
    return request;
  }()
};